/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Flow_Engine_TitleInputs */

const en_services_flow_engine_title = /** @type {(inputs: Services_Flow_Engine_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your Lindevo system`)
};

const lv_services_flow_engine_title = /** @type {(inputs: Services_Flow_Engine_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jūsu Lindevo sistēma`)
};

/**
* | output |
* | --- |
* | "Your Lindevo system" |
*
* @param {Services_Flow_Engine_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_flow_engine_title = /** @type {((inputs?: Services_Flow_Engine_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Flow_Engine_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_flow_engine_title(inputs)
	return en_services_flow_engine_title(inputs)
});